import firebase from '../config/firebase';
require('firebase/auth')
const db = firebase.firestore();

const shipperService = {

    async getShipperAvailable(id){

        return db
            .collection('shipper')
            .doc(id)
            .get();
    },

    async getShipperAllbyCNPJ(cnpj) {
        const shipperQuerySnapshot = await db
            .collection('shipper')
            .where("dataPersonal.documentNumber", "==", cnpj)
            .get();

        if (shipperQuerySnapshot.empty) {
            return null;
            // throw new Error("Transportadora não encontrada.");
        }

        // Assumindo que o CNPJ é único, pegue o primeiro documento
        const shipperDoc = shipperQuerySnapshot.docs[0];
        
        return shipperDoc.data();
    },

    async getShipperbyPrincipal() {
        const shipperQuerySnapshot = await db
            .collection('shipper')
            .where("isPrincipal", "==", true)
            .get();

        if (shipperQuerySnapshot.empty) {
            return null;
            // throw new Error("Transportadora não encontrada.");
        }

        const shipperDoc = shipperQuerySnapshot.docs[0];

        return {
            id: shipperDoc.id,
            ...shipperDoc.data()
        };
    },

    async getShipperUid(cnpj) {
        
        const query = await db.collection('shipper')
            .where("dataPersonal.documentNumber", "==", cnpj)
            .get();

        if (query.empty) {
            return null;
            // throw new Error("Transportadora não encontrada.");
        }

        const shipperDoc = query.docs[0];
        
        return { uid: shipperDoc.id }
    },

    async deleteShipper(id) {
        if (!id) {
            throw new Error("ID do embarcador é obrigatório para exclusão.");
        }

        await db.collection('shipper').doc(id).delete();
    },

}

export default shipperService;